import React from 'react';
import history from 'utils/history';

import JustifyOverlay from '../Modals/JustifyOverlay';

const renderOverlay = (
  overlayData,
  overlayType,
  overlayOpen,
  setOverlayOpen,
) => {
  switch (overlayType) {
    case 'assignEvaluator':
      return (
        <JustifyOverlay
          headText="Atribuir avaliador"
          hasEmployeeSelection
          selectLabel="Novo avaliador"
          data={overlayData}
          isOpen={overlayOpen}
          setIsOpen={setOverlayOpen}
        />
      );
    case 'releaseEvaluation':
      return (
        <JustifyOverlay
          headText="Liberar avaliação fora do período"
          data={overlayData}
          isOpen={overlayOpen}
          setIsOpen={setOverlayOpen}
        />
      );
    default:
      return null;
  }
};

const getStatusCode = status => {
  switch (status) {
    case 'Fora do período':
      return 0;
    case 'Autoavaliação pendente':
      return 1;
    case 'Autoavaliação Concluída':
      return 2;
    case 'Concluído':
      return 3;
    case 'Mediação pendente':
      return 4;
    case 'Mediação rejeitada':
      return 5;
    default:
      return null;
  }
};

const getActionCode = status => {
  switch (status) {
    case 'Indisponível':
      return 0;
    case 'Aguardando início':
      return 1;
    case 'Atribuir mediador':
      return 2;
    case 'Aguardando conclusão':
      return 3;
    case 'Avaliar':
      return 4;
    case 'Ver resultado':
      return 5;
    default:
      return null;
  }
};

const getActionHandler = (status, additionalContent) => {
  switch (status) {
    case 4:
      return history.push({
        pathname: '/',
        state: additionalContent,
      });
    case 6:
      return history.push({
        pathname: '/',
        state: additionalContent,
      });
    default:
      return () => {};
  }
};

export { renderOverlay, getStatusCode, getActionCode, getActionHandler };
